// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.expanded-shrink {\n  transition: margin-left 300ms ease;\n}\n.openSideBarMyClass {\n  margin-left: 50px;\n}\n.closeSideBarMyClass {\n  margin-left: 390px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
